import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { mergeStyles } from 'wix-rich-content-common';
import { SettingsMobileHeader, ModalCloseButton, TextSearchInput } from 'wix-rich-content-ui-components';
import { s as styleInject } from './style-inject.es-746bb8ed.js';
import GiphySelector from './toolbar/giphySelector.js';
import classNames from 'classnames';
import { debounce } from 'lodash';
import { GIPHY_TYPE } from './types.js';

var css_248z = "._3-UeK.oZ9Ny{box-sizing:border-box;overflow:hidden;position:absolute;top:50px;width:100%}[dir] ._3-UeK.oZ9Ny{padding:12px 20px}._3-UeK.oZ9Ny *,._3-UeK.oZ9Ny :after,._3-UeK.oZ9Ny :before{box-sizing:inherit}._3-UeK.oZ9Ny input{box-sizing:border-box}.amUu8{display:flex;font-size:16px;justify-content:space-between;line-height:1.5}[dir] .amUu8{margin-bottom:20px}.NdS6Q{display:grid;grid-template-areas:\"title icon\"}[dir] .NdS6Q{padding-top:15px}[dir=ltr] .NdS6Q{padding-left:20px}[dir=rtl] .NdS6Q{padding-right:20px}.BO4HN{display:flex;grid-area:icon;justify-self:end}[dir=ltr] .BO4HN{padding-right:20px}[dir=rtl] .BO4HN{padding-left:20px}@supports not (contain:inline-size){@media only screen and (min-width:940px){.k8-Gx{width:280px}}}@container (min-width: 940px){.k8-Gx{width:280px}}";
var styles = {"giphy_api_input_modal_container":"_3-UeK","mobile":"oZ9Ny","giphy_modal_header_container":"amUu8","giphy_api_input_modal_navbar":"NdS6Q","giphy_api_input_modal_closeButton":"BO4HN","modalWrapper":"k8-Gx"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class GiphyApiInputModal extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "triggerBi", debounce(() => {
      const { helpers, toolbarName } = this.props;
      helpers == null ? void 0 : helpers.onPluginAction("searchInsideThePlugin", {
        searchTerm: this.state.searchTag,
        plugin_id: GIPHY_TYPE,
        entry_point: toolbarName
      });
    }, 200));
    __publicField(this, "onChange", (searchTag) => {
      this.setState({ searchTag });
      this.triggerBi();
    });
    __publicField(this, "handleClearText", () => {
      this.setState({ searchTag: "" });
    });
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.state = {
      searchTag: ""
    };
  }
  render() {
    const { styles: styles2 } = this;
    const { onGifAdd, t, isMobile, languageDir, theme, onCloseRequested, showCloseButton } = this.props;
    const searchTag = this.state.searchTag;
    return /* @__PURE__ */ React.createElement("div", { dir: languageDir, className: isMobile ? styles2.gif_modal_mobile_container : null }, isMobile && /* @__PURE__ */ React.createElement(
      SettingsMobileHeader,
      {
        theme,
        onCancel: onCloseRequested,
        t,
        title: t("GIFPlugin_Mobile_Header"),
        useNewSettingsUi: true,
        showSaveBtn: false
      }
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles2.giphy_api_input_modal_container, {
          [styles2.mobile]: isMobile
        }),
        "data-hook": "giphyUploadModal"
      },
      showCloseButton && /* @__PURE__ */ React.createElement("div", { className: styles2.giphy_modal_header_container }, /* @__PURE__ */ React.createElement("div", null, t("Giphy_Modal_Header_Title")), /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal: onCloseRequested })),
      /* @__PURE__ */ React.createElement(
        TextSearchInput,
        {
          inputRef: (ref) => this.input = ref,
          onClose: onCloseRequested,
          placeHolder: t("GiphyUploadModal_Search_Placeholder"),
          onChange: this.onChange,
          value: this.state.searchTag,
          "data-hook": "giphyUploadModalInput"
        }
      ),
      /* @__PURE__ */ React.createElement(
        GiphySelector,
        __spreadValues({
          searchTag,
          onCloseRequested,
          onGifAdd
        }, this.props)
      )
    ));
  }
}
GiphyApiInputModal.propTypes = {
  helpers: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  languageDir: PropTypes.string,
  toolbarName: PropTypes.string,
  onGifAdd: PropTypes.func,
  onCloseRequested: PropTypes.func,
  showCloseButton: PropTypes.bool
};

export { GiphyApiInputModal as G, styles as s };
//# sourceMappingURL=giphyApiInputModal-d33234ba.js.map
